// extracted by mini-css-extract-plugin
export default {"containerIframe":"Pesquisa_containerIframe__95YYt","iframe":"Pesquisa_iframe__mxkPc"};